import { ActionIcon, Group, Paper, Popover, Text, TextInput, Button, Stack, Card } from "@mantine/core"
import { Schedule } from "../../utils/schedule"
import { IconClipboard, IconPencil, IconShare } from "@tabler/icons-react"
import { IconTrash } from "@tabler/icons-react"
import { createToast } from "../Toast"
import { useTranslation } from "react-i18next"
import { HOST, PUBLIC_URL } from "../../utils/const"
import { MessageKind } from "../../utils/common"


export const PopoverSharedLink = ({ schedule_uuid }: { schedule_uuid: string }) => {
    const { t } = useTranslation(["app"])

    const url = `${HOST}${PUBLIC_URL}/book?schedule_uuid=${schedule_uuid}`

    const copyToClipboard = () => {
        navigator.clipboard.writeText(url);
        createToast(t("dashboard.link_copied"), MessageKind.Success);
    };

    return (
        <Popover
            position="bottom"
            withArrow
            shadow="md"
        >
            <Popover.Target>
                <div>
                    <Group>
                        <ActionIcon variant="subtle" size="lg" aria-label="Clipboard">
                            <IconShare style={{ width: '70%', height: '70%' }} stroke={1.2} />
                        </ActionIcon>
                    </Group>
                </div>
            </Popover.Target>
            <Popover.Dropdown>
                <Stack>
                    <Group>
                        <TextInput value={url} onChange={() => { }} />
                        <ActionIcon variant="subtle" aria-label="Clipboard" onClick={copyToClipboard}>
                            <IconClipboard style={{ width: '70%', height: '70%' }} stroke={1.2} />
                        </ActionIcon>
                    </Group>
                </Stack>
            </Popover.Dropdown>
        </Popover>
    )
}

export const ScheduleCard = ({ schedule, openEdit, onDelete }: { schedule: Schedule, openEdit: () => void, onDelete: () => void }) => {
    const { t } = useTranslation(["app"])
    return <Paper shadow="xs" p="sm" radius="md" bg='gray.0' withBorder>
        <Group justify='space-between'>
            <Stack gap="0">
                <Text size='lg'>{schedule.name}</Text>
                <Text c='dimmed'>{schedule.description}</Text>
            </Stack>
            <Group>
                <PopoverSharedLink schedule_uuid={schedule.uuid} />
                <ActionIcon variant='subtle' size='lg' onClick={openEdit}>
                    <IconPencil stroke={1.2} />
                </ActionIcon>
                <Popover>
                    <Popover.Target>
                        <ActionIcon variant='subtle' size='lg' color='red'>
                            <IconTrash stroke={1.2} />
                        </ActionIcon>
                    </Popover.Target>
                    <Popover.Dropdown p="0" bg='gray.0'>
                        <Stack gap="md" m="md">
                            <Text>{t("dashboard.sync.valid.are-you-sure")}</Text>
                            <Button color='red' variant="outline" onClick={onDelete}>Delete</Button>
                        </Stack>
                    </Popover.Dropdown>
                </Popover>
            </Group>
        </Group>
    </Paper>
}
